/* ==========================================================================
   MR.VIK — homepage behaviour
   - scroll reveal
   - shoppable reels: viewport-driven autoplay, per-card sound, size tray
   - Buy Now -> add variant -> straight to checkout (prepaid intent)
   - copy discount code
   Adds its own `.mv-js` flag so a load failure can never leave content hidden.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- scroll reveal ---------------- */
  function initReveal() {
    var items = document.querySelectorAll('.mv-rise');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }
    root.classList.add('mv-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-mv-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  /* ---------------- reels ---------------- */
  function initReels() {
    var reels = document.querySelectorAll('.mv-reel');
    if (!reels.length) return;

    // viewport-driven playback: only what's on screen plays
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var card = e.target;
          var v = card.querySelector('video');
          if (!v) return;
          if (e.isIntersecting && e.intersectionRatio > 0.45) {
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay blocked — poster stays */ });
            card.classList.add('is-playing');
          } else {
            v.pause();
            card.classList.remove('is-playing');
          }
        });
      }, { threshold: [0, 0.45, 0.75] });
      for (var i = 0; i < reels.length; i++) vio.observe(reels[i]);
    } else {
      for (var k = 0; k < reels.length; k++) {
        var vv = reels[k].querySelector('video');
        if (vv) { vv.play(); reels[k].classList.add('is-playing'); }
      }
    }

    document.addEventListener('click', function (ev) {
      var t = ev.target;

      // sound toggle
      var mute = t.closest && t.closest('.mv-reel__mute');
      if (mute) {
        ev.preventDefault();
        var card = mute.closest('.mv-reel');
        var v = card && card.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) {
          // only one card audible at a time
          document.querySelectorAll('.mv-reel video').forEach(function (o) {
            if (o !== v) { o.muted = true; syncMuteIcon(o); }
          });
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        }
        syncMuteIcon(v);
        return;
      }

      // buy: single-variant products go straight to their product page,
      // everything else opens the size tray first
      var buy = t.closest && t.closest('.mv-reel__buy');
      if (buy && buy.tagName === 'BUTTON') {
        ev.preventDefault();
        if (buy.hasAttribute('data-variant')) {
          gotoProduct(buy);
        } else {
          closeTrays();
          var c = buy.closest('.mv-reel');
          if (c) c.classList.add('is-picking');
        }
        return;
      }

      // close tray
      var close = t.closest && t.closest('.mv-reel__close');
      if (close) { ev.preventDefault(); closeTrays(); return; }

      // pick a size -> open that product with the size already selected
      var size = t.closest && t.closest('.mv-reel__size');
      if (size && !size.disabled) {
        ev.preventDefault();
        gotoProduct(size);
        return;
      }

      if (!(t.closest && t.closest('.mv-reel__tray'))) closeTrays();
    });
  }

  function syncMuteIcon(video) {
    var card = video.closest('.mv-reel');
    var btn = card && card.querySelector('.mv-reel__mute');
    if (!btn) return;
    btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    btn.setAttribute('data-muted', video.muted ? 'true' : 'false');
    var on = btn.querySelector('[data-icon="on"]');
    var off = btn.querySelector('[data-icon="off"]');
    if (on) on.style.display = video.muted ? 'none' : '';
    if (off) off.style.display = video.muted ? '' : 'none';
  }

  function closeTrays() {
    document.querySelectorAll('.mv-reel.is-picking').forEach(function (c) {
      c.classList.remove('is-picking');
    });
  }

  /* Send the shopper to the product page with ?variant= so Shopify preselects
     the size they tapped. Keeps them on-site to read the detail rather than
     dropping them into checkout. */
  function gotoProduct(btn) {
    var id = btn.getAttribute('data-variant');
    var card = btn.closest('.mv-reel');
    var link = card && card.querySelector('.mv-reel__name');
    if (!link || !link.getAttribute('href')) return;
    var url = link.getAttribute('href').split('?')[0];
    btn.classList.add('is-busy');
    window.location.href = id ? url + '?variant=' + encodeURIComponent(id) : url;
  }

  /* ---------------- copy code ---------------- */
  function initCopy() {
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-mv-copy]');
      if (!b) return;
      ev.preventDefault();
      var code = b.getAttribute('data-mv-copy');
      var done = function () {
        var was = b.textContent;
        b.classList.add('is-done');
        b.textContent = 'Copied ✓';
        setTimeout(function () { b.classList.remove('is-done'); b.textContent = was; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) { /* noop */ }
        document.body.removeChild(ta);
        done();
      }
    });
  }

  /* ---------------- floating header (homepage) ----------------
     Publishes the header's real height as --mv-head-h so the hero can be
     pulled up underneath it, and flips a scrolled state so the transparent
     header regains a surface once it's over content. */
  function initHeader() {
    var header = document.getElementById('site-header');
    if (!header) return;
    var isHome = document.body.classList.contains('mv-home');

    function measure() {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h > 0 && isHome) root.style.setProperty('--mv-head-h', h + 'px');
      return h;
    }
    var h = measure();

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var past = window.pageYOffset > (h || 78);
        document.body.classList.toggle('mv-scrolled', past);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { h = measure(); }, { passive: true });
    onScroll();
  }

  /* ---------------- colour studio ----------------
     Crossfades one silhouette between its colourways. Auto-cycles until the
     visitor interacts, then hands over control for good. */
  function initColourStudio() {
    document.querySelectorAll('[data-mv-colourstudio]').forEach(function (root) {
      var sws = [].slice.call(root.querySelectorAll('.mv-cs__sw'));
      var imgs = [].slice.call(root.querySelectorAll('[data-cs-img]'));
      if (sws.length < 2 || !imgs.length) return;

      var nameEl = root.querySelector('[data-cs-name]');
      var priceEl = root.querySelector('[data-cs-price]');
      var linkEl = root.querySelector('[data-cs-link]');
      var ghost = root.querySelector('[data-cs-ghost]');
      var dur = parseInt(root.getAttribute('data-rotate') || '3600', 10);
      var cur = 0;
      var timer = null;
      var taken = false;   // visitor has taken over

      root.style.setProperty('--cs-dur', dur + 'ms');

      function show(i, fromUser) {
        if (i === cur && !fromUser) return;
        cur = i;
        var sw = sws[i];

        imgs.forEach(function (im) {
          im.classList.toggle('is-on', im.getAttribute('data-cs-img') === String(i));
        });
        sws.forEach(function (s) {
          var on = s === sw;
          s.classList.toggle('is-on', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var nm = sw.getAttribute('data-name') || '';
        if (nameEl) nameEl.textContent = nm;
        if (priceEl) priceEl.textContent = sw.getAttribute('data-price') || '';
        if (linkEl) linkEl.setAttribute('href', sw.getAttribute('data-url') || '#');
        root.style.setProperty('--cs-tint', sw.getAttribute('data-tint') || '#1b1917');

        if (ghost) {
          ghost.textContent = nm;
          ghost.classList.remove('is-swap');
          // force the animation to restart
          void ghost.offsetWidth;
          ghost.classList.add('is-swap');
        }
      }

      function stop() {
        taken = true;
        root.classList.remove('is-cycling');
        if (timer) { clearInterval(timer); timer = null; }
      }

      function start() {
        if (taken || reduce || timer) return;
        root.classList.add('is-cycling');
        timer = setInterval(function () { show((cur + 1) % sws.length, false); }, dur);
      }

      sws.forEach(function (s, i) {
        s.addEventListener('click', function () { stop(); show(i, true); });
        s.addEventListener('mouseenter', function () { if (!taken) show(i, true); });
      });

      // only cycle while the section is actually on screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : (timer && (clearInterval(timer), timer = null)); });
        }, { threshold: 0.35 }).observe(root);
      } else {
        start();
      }

      show(0, true);
    });
  }

  /* stagger: reveal grid children one after another */
  function initStagger() {
    var groups = document.querySelectorAll('.mv-stagger');
    if (!groups.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      groups.forEach(function (g) { g.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---------------- size chart lightbox ---------------- */
  function initSizeChart() {
    document.addEventListener('click', function (ev) {
      var open = ev.target.closest && ev.target.closest('[data-mv-sizechart]');
      if (open) {
        ev.preventDefault();
        var dlg = document.getElementById(open.getAttribute('data-mv-sizechart'));
        if (!dlg) return;
        dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', '');
        return;
      }
      var close = ev.target.closest && ev.target.closest('[data-mv-sizechart-close]');
      if (close) {
        ev.preventDefault();
        var d = close.closest('dialog');
        if (d) d.close ? d.close() : d.removeAttribute('open');
        return;
      }
      // click on the backdrop (the dialog itself, outside its inner box)
      if (ev.target.tagName === 'DIALOG' && ev.target.classList.contains('mv-sc__dlg')) {
        ev.target.close ? ev.target.close() : ev.target.removeAttribute('open');
      }
    });
  }

  function boot() {
    initSizeChart();
    initHeader();
    initReveal();
    initStagger();
    initReels();
    initColourStudio();
    initCopy();
    document.querySelectorAll('.mv-reel video').forEach(syncMuteIcon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


